interface Prop {
  setShowModal: () => void;
}

export default ({ setShowModal }: Prop) => {
  const handleClick = () => {
    setShowModal();
  };

  return (
    <div className="lity lity-opened lity-inline" role="dialog" aria-label="Dialog Window (Press escape to close)" tabIndex={-1} aria-hidden="false" onClick={setShowModal}>
      <div className="lity-wrap" data-lity-close="" role="document">
        <div className="lity-container" onClick={(e) => e.stopPropagation()}>
          <div className="lity-content">
            <div id="login_help" style={{ padding: 10, background: "rgb(255, 255, 255)", maxHeight: 711 }}>
              <h2>Log in</h2>

              <p>Please enter your username and password to login.</p>
            </div>
          </div>
          <button className="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close="" onClick={handleClick}>
            ×
          </button>
        </div>
      </div>
    </div>
  );
};